// extracted by mini-css-extract-plugin
module.exports = {"Editor":"pb6hsRHQ"};